<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="last-name">Фамилия</label>
    <input
      type="text"
      class="form-control"
      id="last-name"
      placeholder="Введите фамилию"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'client-last-name-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ClientLastName.vue?62d344a0